import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import Widget from "@components/Widget/Widget";
import WeatherStatus from "@features/Weather/components/WeatherStatus";
import WeatherTable from "@features/Weather/components/WeatherTable";
import { getTextForecast } from "@features/Weather/services";
import "./DailyWeatherWidget.scss";
import { useIataContext } from "@contexts/IataContext";
const iataToLocationMap = {
    OSL: "Østlandet",
    BGO: "Hordaland",
    TRD: "Trøndelag",
    SVG: "Rogaland",
};
export const DailyWeatherWidget = () => {
    const { iata } = useIataContext();
    const { data: textForecast, isLoading: textLoading, error: textError, } = useQuery({
        queryFn: () => getTextForecast(iata),
        queryKey: ["getTextForecast"],
    });
    return (_jsx(Widget.Container, { children: _jsx(Widget.Body, { children: _jsxs("div", { className: "WeatherWidget-content", children: [_jsx("h2", { children: t("weather.widgets.dailyWeather.title", { location: t(`airportIata.${iata.toLocaleLowerCase()}`) }) }), _jsxs("div", { className: "WeatherWidget-wrapper", children: [_jsx("div", { className: "WeatherWidget-weather-status", children: _jsx(WeatherStatus, { iata: iata }) }), _jsx(WeatherTable, { iata: iata }), _jsx("div", { style: { marginTop: "1.25rem" }, children: !textLoading && textForecast && !textError && (_jsxs(_Fragment, { children: [_jsx("h3", { children: t("weather.widgets.dailyWeather.weatherTable.title", { location: iataToLocationMap[iata] }) }), _jsx("p", { children: textForecast.text })] })) })] })] }) }) }));
};
DailyWeatherWidget.displayName = "DailyWeatherWidget";
